(function ($) {
  $(window).on("load", function() {

    if ($(".subNav-menu").length === 1) {
      $(document).on("click", '.subNav-menu .mobile-nav', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('.subNav-menu .row-wrapper').toggleClass('active');
      });
    }
});

$(document).ready(function () {
  function handleFilterClick(e) {
    var windowWidth = $(window).width();
    if (windowWidth < 991){
      e.stopPropagation()
      e.preventDefault();
      let parentdiv = $(this).closest('li')
      if ($(parentdiv).find('ul').hasClass("active")) {
        $(parentdiv).find('ul').removeClass("active");
      } else {
        $(parentdiv).find('ul').addClass("active");
        // $(this).parents(".filter").siblings().removeClass("active");
      }
    }
  }

  function handleFilterHover() {
    $(this).parent().toggleClass("active");
  }

  
  $(".subNav-menu .menu-item.filter > a").on("click", handleFilterClick);
  $(".subNav-menu .menu-item.filter > span").hover(handleFilterHover);

  // Add click event listener to the document to remove "active" class
  $(document).on("click", function () {
    $(".subNav-menu .menu-item.filter").removeClass("active");
  });
}); 


($(window).on('resize' , function(){
  $('.subNav-menu .mobile-nav').removeClass('active')
  $('.subNav-menu .row-wrapper').removeClass('active');
  $(".subNav-menu .filter .subNav-submenu").removeClass("active");
}));

})(jQuery);